import { render, staticRenderFns } from "./NetBackupList.vue?vue&type=template&id=726c20d7&scoped=true&"
import script from "./NetBackupList.vue?vue&type=script&lang=js&"
export * from "./NetBackupList.vue?vue&type=script&lang=js&"
import style0 from "./NetBackupList.vue?vue&type=style&index=0&id=726c20d7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726c20d7",
  null
  
)

/* custom blocks */
import block0 from "./NetBackupList.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports